/* DUBL Shopify Inbox gate — lightweight version
 * Reveals Shopify Inbox after 25s, at 80% scroll, or on the 3rd page view.
 * Keeps Inbox hidden while the cart drawer is open.
 */
(function () {
  'use strict';

  if (window.__dublChatGateInit) return;
  window.__dublChatGateInit = true;

  var DELAY_MS = 25000;
  var SCROLL_RATIO = 0.8;
  var PAGES_NEEDED = 3;
  var KEY_PAGES = 'dublChatPages';
  var html = document.documentElement;
  var revealed = false;
  var drawerOpen = false;
  var revealTimer = null;
  var chatObserver = null;

  function storageGet(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function storageSet(key, value) {
    try { sessionStorage.setItem(key, value); } catch (e) {}
  }

  function getChat() {
    return document.querySelector('shopify-chat[view="chat"], shopify-chat');
  }

  function enforceChatHost() {
    var chat = getChat();
    if (!chat) return;
    if (revealed && !drawerOpen) {
      chat.style.removeProperty('display');
    } else {
      chat.style.setProperty('display', 'none', 'important');
    }
  }

  function setClasses() {
    html.classList.toggle('dubl-chat-ready', revealed && !drawerOpen);
    html.classList.toggle('dubl-chat-cart-open', drawerOpen);
    enforceChatHost();
  }

  function reveal() {
    if (revealed) return;
    revealed = true;
    if (revealTimer) {
      clearTimeout(revealTimer);
      revealTimer = null;
    }
    window.removeEventListener('scroll', onScroll);
    setClasses();
  }

  function onScroll() {
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - window.innerHeight;
    if (scrollable > 0 && ((window.scrollY || doc.scrollTop) / scrollable) >= SCROLL_RATIO) {
      reveal();
    }
  }

  function syncDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var open = drawer.classList.contains('active');
    if (open !== drawerOpen) {
      drawerOpen = open;
      setClasses();
    }
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(syncDrawer).observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    });
    syncDrawer();
  }

  function watchChatInsertion() {
    var chat = getChat();
    if (chat) {
      enforceChatHost();
      watchChatHost(chat);
      return;
    }

    chatObserver = new MutationObserver(function () {
      var found = getChat();
      if (found) {
        chatObserver.disconnect();
        chatObserver = null;
        enforceChatHost();
        watchChatHost(found);
      }
    });
    chatObserver.observe(document.body, { childList: true, subtree: true });
  }

  function watchChatHost(chat) {
    if (chat.__dublChatHostObserver) return;
    var observer = new MutationObserver(function () {
      if (!revealed || drawerOpen) enforceChatHost();
    });
    observer.observe(chat, { attributes: true, attributeFilter: ['style'] });
    chat.__dublChatHostObserver = observer;
  }

  function countPageViews() {
    var pages = [];
    try { pages = JSON.parse(storageGet(KEY_PAGES) || '[]'); } catch (e) {}
    if (!Array.isArray(pages)) pages = [];
    var path = location.pathname;
    if (pages.indexOf(path) === -1) {
      pages.push(path);
      storageSet(KEY_PAGES, JSON.stringify(pages));
    }
    return pages.length;
  }

  window.dublChatGateDebug = function () {
    return {
      revealed: revealed,
      drawerOpen: drawerOpen,
      chat: getChat(),
      pages: (function () {
        try { return JSON.parse(storageGet(KEY_PAGES) || '[]'); } catch (e) { return []; }
      })()
    };
  };

  // The inline <head> CSS and host enforcement keep the Shadow-DOM widget hidden
  // until a trigger fires, including in Shopify Theme Editor preview mode.
  setClasses();
  watchDrawer();
  watchChatInsertion();

  if (countPageViews() >= PAGES_NEEDED) {
    reveal();
  } else {
    revealTimer = setTimeout(reveal, DELAY_MS);
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
